module.exports = __webpack_public_path__ + "static/media/mc_hipercard.16690f8c.svg";